import * as React from 'react';
import { CircularProgress } from '@mui/material';
import { EmptyState } from '@brightlayer-ui/react-components';
import { RecordData, RecordDataState } from '../../hooks/data-hooks';
import { CenteredContent } from '../CenteredContent';

export const RecordDataLoadingIndicator: React.FC<{ recordData: RecordData }> = (props) => {
    if (props.recordData.state !== RecordDataState.Loading) {
        return null;
    }

    return (
        <CenteredContent>
            <EmptyState icon={<CircularProgress id="progress-spinner" />} title="" />
        </CenteredContent>
    );
};
